import { getSnapShotIndexesInfoManager, getSnapShotIndexesManager } from "@/controllers/gridManager/MarketIndexManager"
import { useEffect } from "react"
import MarketIndex from "."
import cloneDeep from 'lodash/cloneDeep'
import { ALL_INDEXES } from "@/stores/dataStore/memoryStore/const/constIndex"

function ListMarketIndexes() {
    const { getSnapShotIndexesInfoManagerCallAction } = getSnapShotIndexesInfoManager()
    const { getSnapShotIndexesManagerCallAction } = getSnapShotIndexesManager()

    const getMarketIndexInfo = () => {
        getSnapShotIndexesInfoManagerCallAction()
    }

    const getMarketIndexes = () => {
        getSnapShotIndexesManagerCallAction()
    }
    useEffect(() => {
        getMarketIndexInfo()
        getMarketIndexes()
    }, [])

    const ListIndex = cloneDeep(ALL_INDEXES).slice(0, 4)

    return (
        <div style={{ display: 'flex', gap: 10 }}>
            {ListIndex.map((item: any, index: number) => {
                return <MarketIndex key={index} code={item.code} />
            })
            }
        </div>
    )
}

export default ListMarketIndexes